import React from 'react';
import IconButton from 'material-ui/IconButton';
import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import { Grid, Icon } from '../../components';
import PrincipalMaster from '../master/Principal';
import {
    eventoService,
    subeventoService,
    avaliacaoService,
    Utils,
    projetosNotaFinalService,
} from '../../services';

class CalcularMedias extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ano: '',
            dsEventos: [],
            textBuscarEventos: '',
            dsSubeventos: [],
            textBuscarSubeventos: '',
            subeventoSelecionado: '',
            dsProjetosFaltaAvaliar: [],
            linkParaAprovados: '',
        };
    }

    async componentWillMount() {
        const ano = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({
            ano,
            dsEventos: eventos,
        });
    }

    async onCalcular(event) {
        event.preventDefault();
        try {
            let pode = false;
            const { subeventoSelecionado, dsProjetosFaltaAvaliar } = this.state;
            if (dsProjetosFaltaAvaliar.length > 0) {
                pode = window.confirm(
                    'Há resumos/projetos com avaliações pendentes! Calcular mesmo assim?',
                );
            } else {
                pode = window.confirm(
                    'Tem certeza que deseja calcular as médias?',
                );
            }

            if (pode) {
                const save = await projetosNotaFinalService.saveMediaAvaliadores(
                    subeventoSelecionado,
                );
                Utils.showToast(save.message);
            }
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    async getProjetoFaltaAvaliar(subevento, area) {
        const projetos = await avaliacaoService.getProjetoFaltaAvaliar(
            subevento,
            area,
        );
        this.setState({ dsProjetosFaltaAvaliar: projetos });
    }

    async buscarProjetoFaltaAvaliar(subevento) {
        this.setState({
            textBuscarSubeventos: subevento.NOME,
            subeventoSelecionado: subevento.CODIGO,
        });
        this.getProjetoFaltaAvaliar(subevento.CODIGO);
    }

    async buscarEventosPeloAno(ano) {
        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({ dsEventos: eventos });
    }

    async buscarSubEventosPeloEvento(evento) {
        const link = `Endereço para consultar os aprovados: .../projetos-aprovados/${await Utils.getBase64Encode(
            evento.CODIGO.toString(),
        )}`;
        const dadosSubevento = await subeventoService.getSubeventosDoEvento(
            evento.CODIGO,
        );
        this.setState({
            dsSubeventos: dadosSubevento,
            textBuscarEventos: evento.NOME,
            linkParaAprovados: link,
        });
    }

    render() {
        const {
            dsEventos,
            textBuscarEventos,
            dsSubeventos,
            textBuscarSubeventos,
            ano,
            dsProjetosFaltaAvaliar,
            linkParaAprovados,
        } = this.state;

        return (
            <PrincipalMaster title="Calcular Médias" {...this.props}>
                <div className="padding-content">
                    <form onSubmit={(e) => this.onCalcular(e)}>
                        <NumberFormat
                            format="####"
                            customInput={TextField}
                            required
                            value={ano}
                            errorText={ano ? '' : 'Campo obrigatório'}
                            floatingLabelText="Ano"
                            onBlur={() => this.buscarEventosPeloAno(ano)}
                            onChange={(e) =>
                                this.setState({ ano: e.target.value })
                            }
                        />
                        <br />
                        <AutoComplete
                            searchText={textBuscarEventos}
                            floatingLabelText="Selecione um evento"
                            dataSource={dsEventos}
                            openOnFocus="true"
                            dataSourceConfig={{
                                text: 'NOME',
                                value: 'CODIGO',
                            }}
                            onNewRequest={(value) =>
                                this.buscarSubEventosPeloEvento(value)
                            }
                            filter={AutoComplete.noFilter}
                            fullWidth
                        />

                        <AutoComplete
                            searchText={textBuscarSubeventos}
                            fullWidth="true"
                            floatingLabelText="Selecione um subevento"
                            dataSource={dsSubeventos}
                            openOnFocus="true"
                            dataSourceConfig={{
                                text: 'NOME',
                                value: 'CODIGO',
                            }}
                            onNewRequest={(value) =>
                                this.buscarProjetoFaltaAvaliar(value)
                            }
                            filter={AutoComplete.noFilter}
                        />
                        <div>
                            <RaisedButton
                                label="Calcular Médias"
                                primary
                                type="submit"
                            />
                            <br />
                            <div>{linkParaAprovados}</div>

                            <h3>Resumos/Projetos que faltam ser avaliados</h3>
                            <div className="padding-content">
                                <Grid
                                    ref={(ref) => {
                                        this.projetosGridRef = ref;
                                    }}
                                    stripedRows="true"
                                    textTableEmpty="Todos os resumos/projetos foram avaliados."
                                    dataSource={dsProjetosFaltaAvaliar}
                                    columns={[
                                        {
                                            text: 'Nome',
                                            name: 'TITULO',
                                            allowSort: true,
                                            allowSearch: true,
                                            searchOperator: 'LIKE',
                                            width: '850px',
                                        },
                                        {
                                            text: 'Nº Avaliadores',
                                            name: 'QTDEAVALIADORES',
                                            allowSort: true,
                                            allowSearch: true,
                                            searchOperator: 'LIKE',
                                        },

                                        {
                                            text: 'Nº Avaliados',
                                            name: 'QTDEAVALIADO',
                                            allowSort: true,
                                            allowSearch: true,
                                            searchOperator: 'LIKE',
                                        },
                                        {
                                            name: (item) => (
                                                <div>
                                                    <a
                                                        href={`/projeto-info/${item.CODIGO}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <IconButton tooltip="Visualizar">
                                                            <Icon name="visibility" />
                                                        </IconButton>
                                                    </a>
                                                </div>
                                            ),
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

export default CalcularMedias;
